var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinicalA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9V11.6875C22 12.3406 21.5826 12.8962 21 13.1021V39C21 40.6569 22.3431 42 24 42C25.6569 42 27 40.6569 27 39V13.1021C26.4174 12.8962 26 12.3406 26 11.6875V9H28V11.2729C28.5826 11.4788 29 12.0344 29 12.6875V39C29 41.7614 26.7614 44 24 44C21.2386 44 19 41.7614 19 39V12.6875C19 12.0344 19.4174 11.4788 20 11.2729V9H22Z",
    fill: "#0078E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6V8H28V6H20ZM19 4C18.4477 4 18 4.44772 18 5V9C18 9.55228 18.4477 10 19 10H29C29.5523 10 30 9.55228 30 9V5C30 4.44772 29.5523 4 29 4H19Z",
    fill: "#0078E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 20H20V18H28V20Z",
    fill: "#0078E2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalA);
export default __webpack_public_path__ + "static/media/clinical_a.2c8fc82bcf0daea93f74421c606bedc9.svg";
export { ForwardRef as ReactComponent };